import {Component, OnInit, ViewChild} from '@angular/core';
import {TermsService} from 'src/app/services/terms';
import {Modal} from 'src/app/components/modal/Modal';
import {UserService} from 'src/app/services/user.service';

@Component({
  selector: 'acceptance-terms-modal',
  styleUrls: ['./acceptance-terms-modal.component.scss'],
  providers: [TermsService],
  template: `
    <modal
      #modal
      [backdrop]="true"
      [hideCloseButton]="true"
      [closeOnEscape]="false"
    >
      <modal-content class="custom-modal-content">

        <div class='acceptance-terms'>
          <img src="../../../assets/icon/termIcon.svg" alt="Política de privacidade">

          <h1>Atualizamos nossos termos e política de privacidade para você continuar economizando</h1>

          <p>
            Nós nos preocupamos com a segurança dos seus dados, por isso adotamos as diretrizes de transparência
            e conformidade com as obrigações previstas na <b>Lei Geral de Proteção de Dados</b> e demais legislações.
          </p>

          <div class='input-group'>
            <input
              type='checkbox'
              id='term-acceptance'
              [disabled]="loading"
              [checked]="checked"
              (change)='checked = $event.target.checked'
            >
            <label for='term-acceptance'>
              Eu li e <b>estou de acordo</b> com os
              <a
                *ngIf="accountType === 'establishment'"
                target='_blank'
                href="https://privacidade.allya.com.br/contrato-de-parceria">
                Contrato de Parceria
              </a>
              <a
                *ngIf="accountType === 'company'"
                target='_blank'
                href="https://privacidade.allya.com.br/termos-de-uso">
                Termos de Uso
              </a>
               e a <a target='_blank' href='https://privacidade.allya.com.br/politica-de-privacidade'>Política de
              Privacidade</a> da Allya
            </label>
          </div>


          <button (click)="acceptAllTerms()" [disabled]="!checked || loading" class="btn btn-pink" type="button">
            <i *ngIf="loading" class="fa fa-spinner fa-pulse" aria-hidden="true"></i>
            <span *ngIf="!loading">Continuar</span>
          </button>
        </div>
      </modal-content>
    </modal>
  `,
})
export class AcceptanceTermsModalComponent implements OnInit {

  @ViewChild('modal') modal: Modal;

  checked = false;
  accountType: string;
  termsToAccept: string[] = [];
  error = false;
  loading = false;

  constructor(
    private termsService: TermsService,
    private userService: UserService,
  ) {
    this.accountType = this.userService.getTypeAccount();
  }

  async ngOnInit() {
    await this.validateTerms();
  }

  async validateTerms() {
    this.termsToAccept = await this.termsService.getTermsToAccept();

    if (this.termsToAccept.length) {
      this.modal.open();
    }
  }

  async acceptAllTerms() {
    this.loading = true;

    try {
      await this.termsService.acceptAllTerms(this.termsToAccept);
      this.modal.close();
    } catch (e) {
      this.error = true;
      this.loading = false;
    }
  }
}
